























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import TaskProceduresRepository from '@/modules/tasks/procedures/TaskProceduresRepository';
import TaskProcedureCreatePopup from '@/modules/tasks/procedures/components/TaskProcedureCreatePopup.vue';
import TaskProcedureStartPopup from '@/modules/tasks/procedures/components/TaskProcedureStartPopup.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxNavBar } from 'devextreme-vue';
import { mapState } from 'vuex';
import settings from '@/settings.json';

@Component({
  components: {
    Datagrid,
    DxNavBar,
    TaskProcedureCreatePopup,
    TaskProcedureStartPopup,
  },
})
export default class TaskProceduresTable extends Vue {
    private employees: any[] = [];
    private loading: boolean = false;
    private items: ITaskProcedureDto[] = [];
    private selectedProcedure: ITaskProcedureDto | null = null;

    private created() {
        this.loadData();
    }

    private async loadData() {
        try {
            this.loading = true;
            this.items = (await TaskProceduresRepository.getAll()).data;
        } catch {
            notificationService.showErrorMessage('Mislukt om de procedures te laden!');
        } finally {
            this.loading = false;
        }
    }

    private refresh() {
      try {
        ((this.$refs.grid as Datagrid).$refs.taskProceduresGrid as any).instance.refresh();
      } catch {
        notificationService.showErrorMessage('Mislukt om de grid te refreshen!');
      }
    }

    private editRow(e: any) {
        if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
            this.$router.push({ path: `/tasks/procedures/${e.data.id}` });
        }
    }

    private async deleteRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await TaskProceduresRepository.delete(e.data.id);
                notificationService.saved();
                resolve(false);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    private add() {
        (this.$refs.TaskProcedureCreatePopup as TaskProcedureCreatePopup).show();
    }

    private start(e: any) {
        this.selectedProcedure = e.row.data;
        setTimeout(() => {
            (this.$refs.TaskProcedureStartPopup as TaskProcedureStartPopup).show();
        }, 50);
    }

    get columns() {
        const self = this;
        return [
            {
                dataField: 'name',
                caption: 'Naam',
            },
            {
                type: 'buttons',
                buttons: [
                    {
                        icon: 'fas fa-play',
                        onClick: (e: any) => {
                            // do sth
                            self.start(e);
                        },
                        /*visible: (e: any) => {
                            if (e.row.isEditing) {
                                return false;
                            }
                            return e.row.data.custom;
                        },*/
                    },
                    'edit',
                    'delete',
                ],
            },
        ];
    }

    get toolbarOptions() {
        const self = this;

        return [
            {
                location: 'before',
                widget: 'dxButton',
                options: {
                icon: 'fas fa-plus',
                text: 'Toevoegen',
                stylingMode: 'outlined',
                type: 'success',
                onClick: this.add,
                },
            },
        ];
    }

}
